const Spinner = () => (
    <div className="lds-facebook"><div></div><div></div><div></div></div>
)

export default Spinner